var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        printButton: true,
        downloadButton: true,
        close: _vm.closeModal,
        printStyle: _vm.printStyle,
        title: "Проверки " + _vm.companyName,
      },
    },
    [
      _c("template", { slot: "modalHeader" }, [
        _c("h3", { staticClass: "modal-title" }, [
          _c("i", { staticClass: "uk-icon-bolt" }),
          _vm._v(" Проверки " + _vm._s(_vm.companyName)),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal-content",
          attrs: { slot: "modalBody" },
          slot: "modalBody",
        },
        [
          _vm.isLoading ? _c("loading") : _vm._e(),
          _vm._v(" "),
          !_vm.isLoading && _vm.inspectionList && _vm.inspectionList.length
            ? _c("div", { staticClass: "inspection-list" }, [
                _c(
                  "ul",
                  { staticClass: "list" },
                  _vm._l(_vm.inspectionList, function (e, i) {
                    return _c("inspection-info", {
                      key: i,
                      attrs: { inspection: e },
                    })
                  }),
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.pagination && _vm.pagination.pages_count > 1
        ? _c(
            "div",
            {
              staticClass: "modal-footer",
              attrs: { slot: "modalFooter" },
              slot: "modalFooter",
            },
            [
              _c("old-pagination", {
                attrs: {
                  paginationObj: _vm.pagination,
                  getNewContent: _vm.paginationCallback,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }